import { render, staticRenderFns } from "./AAuditProgramGroupCard.vue?vue&type=template&id=6252465e&scoped=true&"
import script from "./AAuditProgramGroupCard.vue?vue&type=script&lang=ts&"
export * from "./AAuditProgramGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./AAuditProgramGroupCard.vue?vue&type=style&index=0&id=6252465e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252465e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
